function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Notification = function Notification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M3.9 19.63h16.21c.76 0 1.21-.73 1.37-1.38.37-1.3-.43-2.51-1.39-3.13-.54-.35-.72-.8-.72-1.79v-2.88q0-.187.005-.37a18 18 0 0 0 .006-.493c.01-.812.02-1.649-.141-2.477-.5-2.51-2-4.44-4.13-5.28-.64-.25-1.31-.42-1.98-.49-.73-.08-1.51-.08-2.25 0-.67.07-1.34.24-1.98.49-2.13.84-3.63 2.76-4.13 5.28-.18.87-.16 1.75-.14 2.6.01.25.01.5.01.74v2.88c0 .99-.18 1.44-.72 1.79-.96.62-1.77 1.83-1.4 3.11.17.68.62 1.4 1.38 1.4m16.03-1.5H4.08a2 2 0 0 1-.11-.29c-.16-.56.28-1.15.76-1.46 1.24-.81 1.41-1.99 1.41-3.05v-2.88q-.001-.194-.005-.385L6.13 9.68l-.002-.152c-.01-.753-.02-1.462.112-2.128.4-2.04 1.54-3.52 3.21-4.18.51-.2 1.04-.33 1.58-.39.64-.07 1.31-.07 1.94 0 .53.05 1.06.19 1.58.39 1.67.66 2.81 2.14 3.21 4.18.14.71.13 1.47.11 2.28-.01.26-.01.52-.01.77v2.88c0 1.06.17 2.25 1.41 3.05.48.31.93.9.76 1.49-.02.08-.06.19-.1.26m-9.79 4.59h3.72c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.72c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
export default Notification;
Notification.displayName = 'Notification';